import { render, staticRenderFns } from "./SettingsLogin.vue?vue&type=template&id=c6c11754"
import script from "./SettingsLogin.vue?vue&type=script&lang=js"
export * from "./SettingsLogin.vue?vue&type=script&lang=js"
import style0 from "./SettingsLogin.vue?vue&type=style&index=0&id=c6c11754&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
